export const CREDIT_CARD = 'card';
export const PAYPAL = 'paypal';
